import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import type { StrugglingResponse } from "@mubin/contracts";
import { api } from "../lib/api";
import { strugglingIndicatorLabel } from "../lib/policies";
import { Badge, Loading } from "./ui";

/** Students of a circle who meet the program's struggling indicators (B10), with the reasons. */
export function StrugglingCard({ circleId }: { circleId: string }) {
  const date = new Date().toISOString().slice(0, 10);
  const q = useQuery({
    queryKey: ["struggling", circleId, date],
    queryFn: () => api<StrugglingResponse>(`/v1/circles/${circleId}/struggling?date=${date}`),
  });
  const r = q.data;
  return (
    <section className="card">
      <div className="card-h">
        <h2>يحتاجون متابعة</h2>
        {r?.rules && (
          <span className="muted small">
            آخر {r.rules.periodDays} يومًا · {r.rules.minIndicators} مؤشر على الأقل
            {r.rules.provisional ? " · مؤشرات أولية" : ""}
          </span>
        )}
      </div>
      <div className="section">
        {q.isPending ? (
          <Loading rows={2} />
        ) : !r ? (
          <p className="muted">تعذر التحميل.</p>
        ) : !r.rules ? (
          <p className="muted">
            لم تُحدد مؤشرات الطالب المتعثر بعد. <Link to="/policies">حدّدها من سياسات البرامج</Link>.
          </p>
        ) : r.students.length === 0 ? (
          <p className="muted">لا أحد يبلغ مؤشرات التعثر حاليًا.</p>
        ) : (
          <ul className="list">
            {r.students.map((s) => (
              <li key={s.enrollmentId}>
                <Link to="/users/$userId" params={{ userId: s.student.id }}>
                  <b>{s.student.name}</b>
                </Link>{" "}
                {s.reasons.map((x) => (
                  <Badge key={x.indicator} tone="warning">
                    {strugglingIndicatorLabel[x.indicator]}: {x.value}
                  </Badge>
                ))}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
